import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a025b4e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "join"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'Joining',
  props: {
  isJoining: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_DoubleBounceLoader = _resolveComponent("DoubleBounceLoader")!

  return (__props.isJoining)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DoubleBounceLoader, { size: 40 }),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('joining')) + "...", 1),
          _hoisted_2,
          _createTextVNode(_toDisplayString(_ctx.$t('joining-message')), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})